import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import "../Reports.css";

function AllOrdersReport() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get("https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/allOrder");
            const ordersData = response.data.split("\n\n")
                .filter(order => order.trim() !== "")
                .map(order => {
                    const lines = order.split("\n");
                    const orderId = lines.find(line => line.startsWith("Идентификатор заказа: "))?.split(": ")[1];
                    const nameOrder = lines.find(line => line.startsWith("Название заказа: "))?.split(": ")[1];
                    const descriptionOrder = lines.find(line => line.startsWith("Описание заказа: "))?.split(": ")[1];
                    const typeOrder = lines.find(line => line.startsWith("Тип заказа: "))?.split(": ")[1];
                    const status = lines.find(line => line.startsWith("Статус: "))?.split(": ")[1];

                    if (orderId && nameOrder && typeOrder && status) {
                        return { orderId, nameOrder, descriptionOrder, typeOrder, status };
                    } else {
                        return null;
                    }
                })
                .filter(order => order !== null);

            setOrders(ordersData);
        } catch (error) {
            console.error("Ошибка при получении данных:", error);
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по всем заказам",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        ...orders.map(order => [
                            new Paragraph({
                                text: `Идентификатор заказа: ${order.orderId}`,
                            }),
                            new Paragraph({
                                text: `Название заказа: ${order.nameOrder}`,
                            }),
                            new Paragraph({
                                text: `Описание заказа: ${order.descriptionOrder || "Нет описания"}`,
                            }),
                            new Paragraph({
                                text: `Тип заказа: ${order.typeOrder}`,
                            }),
                            new Paragraph({
                                text: `Статус: ${order.status}`,
                            }),
                            new Paragraph({
                                text: "",
                            }),
                        ]).flat(),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "all_orders_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>📋 Все заказы</h2>

            {orders.length > 0 && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Найдено заказов: <span className="otch-highlight">{orders.length}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "📊 Получить все заказы"
                    )}
                </button>
                {orders.length > 0 && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>
        </div>
    );
}

export default AllOrdersReport;